<footer
  id="contactUs"
  class="relative py-16 px-6 lg:px-12 overflow-hidden"
  style="background: var(--theme-bg); border-top: 1px solid var(--theme-border);"
  *transloco="let t"
>
  <div class="dot-accent-tr" aria-hidden="true"></div>

  <div class="max-w-7xl mx-auto" style="position:relative;z-index:1">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
      <!-- Brand column -->
      <div class="lg:col-span-2">
        <img
          [src]="themeService.isDarkMode() ? '/assets/images/logobwhd2.png' : '/assets/images/aurrica-logo.png'"
          class="h-9 w-auto mb-4"
          alt="Aurrica"
          width="128"
          height="36"
        />
        <p
          class="max-w-xs text-sm leading-relaxed"
          style="color: var(--theme-text-dim)"
        >
          {{ t('home.description') }}
        </p>
      </div>

      <!-- Contact column -->
      <div>
        <h3
          class="text-xs uppercase tracking-widest font-semibold mb-4"
          style="color: var(--theme-text-muted)"
        >
          Contact
        </h3>
        <address
          class="not-italic space-y-1.5 text-sm"
          style="color: var(--theme-text-dim)"
        >
          <p>Silverback Mall, 3rd Floor</p>
          <p>Kicukiro, Kigali, Rwanda</p>
          <p class="pt-1">
            <a
              href="tel:+250789399601"
              class="transition-colors hover:text-white"
              >+250 789 399 601</a
            >
          </p>
          <p>
            <a
              href="mailto:info@aurrica.com"
              class="transition-colors hover:text-white"
              >info&#64;aurrica.com</a
            >
          </p>
        </address>
      </div>

      <!-- Platform links column -->
      <div>
        <h3
          class="text-xs uppercase tracking-widest font-semibold mb-4"
          style="color: var(--theme-text-muted)"
        >
          Platform
        </h3>
        <ul class="space-y-2 text-sm" style="color: var(--theme-text-dim)">
          <li>
            <a
              [href]="freightLoginUrl"
              target="_blank"
              rel="noopener"
              class="transition-colors hover:text-white"
            >
              {{ t('home.freighMarketPlace') }}
            </a>
          </li>
          <li>
            <a
              [href]="fleetLoginUrl"
              target="_blank"
              rel="noopener"
              class="transition-colors hover:text-white"
            >
              {{ t('home.fleetManagment') }}
            </a>
          </li>
          <li>
            <a href="#features" class="transition-colors hover:text-white"
              >{{ t('navbar.features') }}</a
            >
          </li>
          <li>
            <a href="#marketplace" class="transition-colors hover:text-white"
              >{{ t('marketplace.label') }}</a
            >
          </li>
          <li>
            <a href="#faq" class="transition-colors hover:text-white"
              >{{ t('navbar.faq') }}</a
            >
          </li>
        </ul>
      </div>
    </div>

    <!-- Bottom bar -->
    <div
      class="flex flex-col sm:flex-row justify-between items-center gap-4 pt-8"
      style="border-top: 1px solid var(--theme-border)"
    >
      <p class="text-xs" style="color: var(--theme-text-muted)">
        {{ t('copyright') }} © {{ year }} {{ t('company') }}. {{
        t('allRightReserved') }}
      </p>
      <p class="text-xs" style="color: var(--theme-text-muted)">
        Kigali, Rwanda &nbsp;·&nbsp; info&#64;aurrica.com
      </p>
    </div>
  </div>
</footer>
